import styled from 'styled-components'

export const GlassDoorContainer = styled.div`
  display: flex;

  width: 100%;
  max-width: 1440px;
  height: 705px;
  background-color: ${({ theme }) => theme.colors.white};

  .container-img {
    height: 100%;
    display: flex;
    justify-content: center;
    position: relative;
    .nata-image {
      margin-top: auto;
      opacity: 0;
      transition: all 0.5s;
      transform: translateX(30%) scale(0.95);
      object-fit: cover;

      &.active {
        opacity: 1;
        transform: translateX(-10%) scale(1);
      }
    }
    .nata-image-blur {
      display: none;
    }
  }

  @media (max-width: 1403px) {
    flex-direction: column-reverse;
    align-items: center;

    height: fit-content;

    background-color: ${({ theme }) => theme.colors.black};

    .container-img .nata-image {
      margin: 0;
      &.active {
        transform: translateX(0%) scale(1);
      }
    }

    .container-img {
      width: 100%;
      z-index: 0;
      overflow: hidden;
      .nata-image {
        margin: 0;
      }

      .nata-image-blur {
        display: flex;
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        filter: blur(1.5vw);
      }
    }
  }

  @media (max-width: 500px) {
    height: 528px;

    background-color: ${({ theme }) => theme.colors.black};

    .container-img {
      width: 100%;
      z-index: 0;
      overflow: visible;

      .nata-image {
        width: 100%;
        height: 190px;
        margin: 0;
        max-width: 258px;
      }

      .nata-image-blur {
        display: flex;
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        filter: blur(2px);
      }
    }
  }
`

export const GlassdoorTextContainer = styled.div`
  padding: 0 140px 80px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.black};

  width: 851px;
  height: 680px;

  color: ${({ theme }) => theme.colors.white};

  .score-button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    a button {
      line-height: 24px;
    }
  }

  @media (max-width: 1403px) {
    width: 100%;
    padding: 0 100px 60px;
  }

  @media (max-width: 742px) {
    padding: 0 16px;
    height: auto;
    gap: 8px;
    margin: 48px 0 24px;
    justify-content: flex-start;

    .glassdoor-title {
      margin: 0 27px;
    }
    .glassdoor-description {
      margin: 0 30px;
    }

    .score-button-container {
      flex-direction: column;
      gap: 8px;
      flex-grow: 1;
    }
  }

  @media (max-width: 500px) {
    justify-content: center;
    .glassdoor-title,
    .glassdoor-description {
      margin: 0;
    }
  }

  @media (min-width: 700px) and (max-height: 750px) {
    gap: 50px;
    padding: 50px 60px;
  }
`

export const GlassdoorReviewContainer = styled.div`
  display: flex;

  width: 281.5px;

  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  align-items: center;

  .glassdoor {
    flex-basis: 100%;
    text-align: center;
  }

  .glassdoor-score {
    border-right: 1px solid ${({ theme }) => theme.colors.white};
    padding-right: 8px;
  }

  @media (max-width: 742px) {
    width: fit-content;
  }

  @media (max-width: 600px) {
    width: 173px;
    height: 67px;
    margin-left: 5px;
  }
`

type StarContainerProps = {
  filledPercent: number
}

export const StarContainer = styled.div<StarContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  padding: 2px;
  border-radius: 2px;

  img {
    margin: 0;
  }

  background: ${({ filledPercent }) => `linear-gradient(
      90deg,
      #0caa41 -0.78%,
      rgba(12, 170, 65, 0.947917) ${filledPercent}%,
      rgba(65, 78, 69, 0.69) ${filledPercent}%
    );`};
`
